import React from 'react';

export default function QuotationBankTermsFooter({ companyDetails, terms, variant = 'standard' }) {
  const hasBank =
    companyDetails.bankName ||
    companyDetails.bankAccount ||
    companyDetails.bankIfsc ||
    companyDetails.upiId ||
    companyDetails.upiQrUrl ||
    companyDetails.paymentGatewayLink;

  if (!hasBank && !terms && !companyDetails.sealUrl && !companyDetails.signUrl && !companyDetails.footer) {
    return null;
  }

  const bankBoxClass =
    variant === 'colored'
      ? 'quotation-bank-box w-full sm:w-1/2 border-l-4 border-indigo-200 bg-indigo-50/50 p-3 rounded-r text-sm'
      : 'quotation-bank-box w-1/2 border border-gray-200 bg-slate-50 p-3 rounded text-sm';
  const termsBoxClass =
    variant === 'colored'
      ? 'quotation-terms-box w-full sm:w-1/2 border-l-4 border-teal-200 bg-teal-50/50 p-3 rounded-r text-sm'
      : 'quotation-terms-box w-1/2 border border-gray-200 bg-slate-50 p-3 rounded text-sm';
  const bankTitleClass = variant === 'colored' ? 'quotation-section-title text-indigo-600' : 'quotation-section-title text-gray-800';
  const termsTitleClass = variant === 'colored' ? 'quotation-section-title text-teal-600' : 'quotation-section-title text-gray-800';
  const rowClass =
    variant === 'colored'
      ? 'quotation-post-items-row flex flex-col sm:flex-row gap-4'
      : 'quotation-post-items-row flex flex-row gap-4';
  const footerClass =
    variant === 'colored'
      ? 'mt-6 text-center text-xs text-gray-600 bg-slate-50/80 p-3 rounded-lg border border-slate-200/70'
      : 'mt-4 text-center text-xs text-gray-500 border-t pt-2';

  return (
    <div className="quotation-post-items">
      {(hasBank || terms) && (
        <div className={variant === 'colored' ? 'mt-4 mb-2' : 'mt-2 mb-2'}>
          <div className={rowClass}>
            {hasBank && (
              <div className={bankBoxClass}>
                <div className={bankTitleClass}>Bank Details</div>
                {companyDetails.bankName && (
                  <div className="quotation-bank-line text-gray-700">
                    {variant === 'colored' && <span className="font-medium">Bank: </span>}
                    {variant !== 'colored' && 'Bank: '}
                    {companyDetails.bankName}
                  </div>
                )}
                {companyDetails.bankAccount && (
                  <div className="quotation-bank-line text-gray-700">
                    {variant === 'colored' ? <span className="font-medium">Account No: </span> : 'Account No: '}
                    {companyDetails.bankAccount}
                  </div>
                )}
                {companyDetails.bankIfsc && (
                  <div className="quotation-bank-line text-gray-700">
                    {variant === 'colored' ? <span className="font-medium">IFSC: </span> : 'IFSC: '}
                    {companyDetails.bankIfsc}
                  </div>
                )}
                {companyDetails.upiId && (
                  <div className="quotation-bank-line text-gray-700">
                    {variant === 'colored' ? <span className="font-medium">UPI: </span> : 'UPI: '}
                    {companyDetails.upiId}
                  </div>
                )}
                {companyDetails.upiQrUrl && (
                  <img src={companyDetails.upiQrUrl} alt="UPI QR" className="quotation-bank-qr w-20 h-20 object-contain mt-2" />
                )}
                {companyDetails.paymentGatewayLink && (
                  <div className="quotation-bank-line mt-1 text-xs break-all">
                    {variant === 'colored' ? <span className="font-medium">Payment Link: </span> : 'Payment Link: '}
                    <a
                      href={companyDetails.paymentGatewayLink}
                      className="text-blue-600 underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {companyDetails.paymentGatewayLink}
                    </a>
                  </div>
                )}
              </div>
            )}
            {terms && (
              <div className={termsBoxClass}>
                <div className={termsTitleClass}>
                  {variant === 'colored' ? 'Terms & Conditions' : 'Terms and Conditions'}
                </div>
                <div
                  className={`quotation-terms-body whitespace-pre-line text-gray-700 text-xs${variant === 'colored' ? ' leading-relaxed' : ''}`}
                >
                  {terms}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      <div className={`quotation-signature-row flex flex-row items-end justify-end gap-8 ${variant === 'colored' ? 'mt-6' : 'mt-8'} mb-2`}>
        {companyDetails.sealUrl && (
          <div className={`quotation-signature-block flex flex-col items-center${variant === 'standard' ? ' mr-4' : ''}`}>
            <img src={companyDetails.sealUrl} alt="Seal" className="h-14 w-14 object-contain mb-1" />
            <div className={`quotation-signature-label text-xs ${variant === 'colored' ? 'text-gray-600' : 'text-gray-500'}`}>
              Company Seal
            </div>
          </div>
        )}
        {companyDetails.signUrl && (
          <div className="quotation-signature-block flex flex-col items-center">
            <img src={companyDetails.signUrl} alt="Sign" className="h-14 w-14 object-contain mb-1" />
            <div className={`quotation-signature-label text-xs ${variant === 'colored' ? 'text-gray-600' : 'text-gray-500'}`}>
              Authorised Signatory
            </div>
          </div>
        )}
      </div>

      {companyDetails.footer && <div className={footerClass}>{companyDetails.footer}</div>}
    </div>
  );
}
